import Vue from 'vue';
import { mapState } from 'vuex';
export default Vue.extend({
    computed: {
        ...mapState('productModule', ['currentProduct', 'currentVariant']),
        product() {
            return this.currentProduct;
        },
    },
});
